import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles, children, fallback = null }) => {
  const { token, user } = useSelector((state) => state.auth);
  const location = useLocation();

  // Not logged in at all → send to home (you could also send to login)
  if (!token || !user) {
    return fallback;
    // return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Logged in but role not allowed
  if (
    Array.isArray(allowedRoles) &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user.role)
  ) {
    return fallback;
    // return <Navigate to="/" replace />;
    // Or show a "Not authorized" component instead
  }

  // All good → render the page
  return children;
};

export default ProtectedRoute;
